import appApi from "./api";

export const cotizacionFactorajeService = {
  get() {
    return appApi().get("cotizaciones/factoraje");
  },

  store(body) {
    return appApi().post("cotizaciones/factoraje/store", body);
  },

  getById(cotizacion_id) {
    return appApi().get(`cotizaciones/factoraje/${cotizacion_id}/detalle`);
  },
};
